import React from "react";

import { connect } from "react-redux";
import { Input } from "../../Input";
import { Button } from "../../Button";
import language from "../../../language";
import axios from "axios";
import toastMessage from "../../../utils/toastMessage";
import { getStorage } from "../../../utils/storage";
import icons from "../../../constants/icons";
import { fetchMerchantVerifications } from "../../../queries/verification/merchantVerficationQuery";
import { getAccountMerchantProfileInfo } from "../../../queries/profile/merchantProfile";
import api from "../../../utils/api";

class VerifyOTP extends React.Component {
  state = {
    isSubmitting: false,
    error: {},
    otp: "",
    user: {},
    verificationEmail: {},
    verificationKYC: {},
  };

  componentDidMount = async () => {
    const user = await getStorage();
    await this.setState({ user });

    await this.getVerifications(true);
  };

  getAccountProfile = async () => {
    const { defaultLanguage } = this.props;

    let data = await getAccountMerchantProfileInfo(defaultLanguage);

    return data;
  };

  getVerifications = async (isLoading) => {
    const { defaultLanguage } = this.props;
    let { verificationEmail, verificationKYC } = this.state;

    try {
      this.setState({ isLoading });

      let data = await fetchMerchantVerifications(defaultLanguage);

      data.forEach((el) => {
        if (el.verificationType === "EMAIL") {
          verificationEmail = el;
        }

        if (el.verificationType === "KYC_DOCUMENT_VERIFICATION") {
          verificationKYC = el;
        }
      });

      this.setState({ verificationEmail, verificationKYC });
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  onChangeText = (field, e) => {
    let { error } = this.state;

    delete error[field];
    delete error["verificationTypeId"];

    this.setState({ [field]: e.target.value });
  };

  validateForm = () => {
    let { error, otp, verificationEmail } = this.state;

    if (otp === "") {
      error.otp = language[this.props.defaultLanguage].otp_required;
    }

    if (!verificationEmail.verificationTypeId) {
      error.verificationTypeId =
        language[this.props.defaultLanguage].verification_type_id_missing;
      toastMessage(
        "error",
        language[this.props.defaultLanguage].verification_type_id_missing
      );
    }

    this.setState({ error });
  };

  onSubmit = async (e) => {
    e.preventDefault();

    await this.validateForm();

    if (Object.keys(this.state.error).length === 0) {
      this.setState({ isSubmitting: true });

      const { otp, user, verificationEmail } = this.state;

      const { verificationTypeId } = verificationEmail;
      const { sub: userId } = user;

      const options = {
        method: "PUT",
        url: `${api("account")}/otp`,
        data: {
          userId,
          otp,
          verificationTypeId,
        },
        headers: {
          Authorization: `Bearer ${user.accessToken}`,
        },
      };

      axios(options)
        .then((data) => {
          this.setState({ isSubmitting: false });

          if (data.data.status === "error")
            return toastMessage("error", data.data.message);

          this.onSuccess(data.data);
        })
        .catch((error) => {
          this.setState({ isSubmitting: false });

          toastMessage(
            "error",
            language[this.props.defaultLanguage].unable_to_verify_email_address
          );
        });
    }
  };

  onSuccess = async () => {
    const { verificationKYC } = this.state;

    const { status, verificationTypeId } = verificationKYC;

    //get account profile information
    const { categoryName = "" } = await this.getAccountProfile();

    if (!status && categoryName === "Individual")
      return (window.location.href = `/merchant/verification/kyc/files/${verificationTypeId}`);

    if (!status) return (window.location.href = `/merchant/kyc/onboarding`);

    window.location.href = "/merchant/home";
  };

  resendOTP = async (e) => {
    e?.preventDefault();

    const { user } = this.state;
    const { preferred_username } = user;

    this.setState({
      isResending: true,
    });

    const options = {
      method: "POST",
      url: `${api("account")}/otp`,
      data: {
        email: preferred_username,
      },
      headers: {
        Authorization: `Bearer ${user.accessToken}`,
      },
    };

    axios(options)
      .then((data) => {
        this.setState({ isResending: false });

        toastMessage(
          "success",
          language[this.props.defaultLanguage].otp_resent_successfully
        );
      })
      .catch((error) => {
        this.setState({ isResending: false });

        toastMessage(
          "error",
          language[this.props.defaultLanguage].otp_resent_failed
        );
      });
  };

  handleBackPressed() {
    sessionStorage.clear();

    window.location.href = "/login";
  }

  render() {
    return (
      <>
        <div className="auth-form">
          <div className="title">
            <h3 className="text-primary">
              {language[this.props.defaultLanguage].verify_email_title}
            </h3>
            <p>
              {`${language[this.props.defaultLanguage].enter_otp_description} `}
              {this.props.email && (
                <span className="text-bold">{this.props.email}</span>
              )}
            </p>
          </div>
          <form>
            <Input
              label={language[this.props.defaultLanguage].otp_code}
              placeholder={
                language[this.props.defaultLanguage].otp_code_placeholder
              }
              required
              leftIcon={icons.key}
              value={this.state.otp}
              error={this.state.error.otp}
              onChange={(e) => this.onChangeText("otp", e)}
              labelLinkRightText={
                language[this.props.defaultLanguage].resend_otp
              }
              onPressLabelLink={this.resendOTP.bind(this)}
              labelLinkRightTextLoading={this.state.isResending}
              maxLength={5}
            />
            <Button
              text={language[this.props.defaultLanguage].verify}
              className="w-100"
              isSubmitting={this.state.isSubmitting}
              onPress={this.onSubmit.bind(this)}
            />
            <div className="mt-3">
              <Button
                type="link"
                text={language[this.props.defaultLanguage].go_back}
                className="btn-transparent w-100"
                to="#"
                onPress={this.handleBackPressed.bind(this)}
              />
            </div>
          </form>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(VerifyOTP);
